import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import RothSelect from '../components/RothSelect.js';

export default class ProjectPage extends Component {
  style = {};
  render = () => (
    <div className="content">
      <div className="inner">
        <div>
          <h1>{this.props.text('project', 'h1')}</h1>
          <p>{this.props.text('project', 'desc')}</p>
          <div style={{ padding: '20px 40px 0px 40px' }}>
            <h2 style={{ color: 'gray' }}>{this.props.text('project', 'h2')}</h2>
            <RothSelect
              param="heatSource"
              value={this.props.project.heatSource}
              fn={this.props.changeProjectParam}
              options={this.props.options.heatSource.reduce((ret, key) => {
                ret[key] = this.props.text('project', 'heatSource_' + key);
                return ret;
              }, {})}
            >
              {this.props.text('project', 'i1')}
            </RothSelect>
            <RothSelect
              param="manifold"
              value={
                ['shuntunit', 'minishunt', 'minishuntWireless'].includes(this.props.project.heatSource) ? '' : this.props.project.manifold
              }
              fn={this.props.changeProjectParam}
              disabled={['shuntunit', 'minishunt', 'minishuntWireless'].includes(this.props.project.heatSource)}
              options={this.props.options.manifold.reduce((ret, key) => {
                ret[key] = this.props.text('project', 'manifold_' + key);
                return ret;
              }, {})}
            >
              {this.props.text('project', 'i3')}
            </RothSelect>
            <RothSelect
              param="regulationSystem"
              value={['minishunt', 'minishuntWireless'].includes(this.props.project.heatSource) ? '' : this.props.project.regulationSystem}
              fn={this.props.changeProjectParam}
              disabled={['minishunt', 'minishuntWireless'].includes(this.props.project.heatSource)}
              options={this.props.options.regulationSystem.reduce((ret, key) => {
                ret[key] = this.props.text('project', 'regulationSystem_' + key);
                return ret;
              }, {})}
            >
              {this.props.text('project', 'i4')}
            </RothSelect>
            <RothSelect
              param="cabinet"
              value={this.props.project.cabinet}
              fn={this.props.changeProjectParam}
              options={this.props.options.cabinet.reduce((ret, key) => {
                ret[key] = this.props.text('project', 'cabinet_' + key);
                return ret;
              }, {})}
            >
              {this.props.text('project', 'i2')}
            </RothSelect>
            <RothSelect
              param="insulation"
              value={this.props.project.cabinet === 'cabinet' ? '' : this.props.project.insulation}
              fn={this.props.changeProjectParam}
              disabled={this.props.project.cabinet === 'cabinet'}
              options={this.props.options.insulation.reduce((ret, key) => {
                ret[key] = this.props.text('project', 'insulation_' + key);
                return ret;
              }, {})}
            >
              {this.props.text('project', 'i5')}
            </RothSelect>
          </div>
        </div>
      </div>
      <RothButton disabled={!this.props.isPageAllowed('rooms')} type="wide" fn={this.props.changePage} value="rooms">
        {this.props.text('project', 'specifyRooms')}
      </RothButton>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/ProjectPage.js
 **/